import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, FileSpreadsheet, Gamepad2, MessageCircle, ShieldAlert, Smartphone, ChevronDown } from 'lucide-react';
const bonos = [{
  id: 1,
  icon: <Gift className="w-8 h-8" data-id="element-17" />,
  title: 'BONO 1 — BANCO DE EJERCICIOS ACUÁTICOS ILUSTRADO',
  originalPrice: '$15.000',
  content: ['+100 ejercicios acuáticos categorizados por objetivo y zona de trabajo', 'Descripción clara de posición inicial, ejecución y finalización de cada ejercicio', 'Objetivo específico de cada ejercicio: para qué sirve y cuándo usarlo en tu clase', 'Variantes por nivel de dificultad: con y sin material', 'Formato visual e imprimible para tener al borde de la pileta', 'Organizado por zona de trabajo, objetivo y nivel de dificultad', 'Ejercicios con paletas, pullbuoy, tabla, noodle y sin material']
}, {
  id: 2,
  icon: <FileSpreadsheet className="w-8 h-8" data-id="element-18" />,
  title: 'BONO 2 — PLANILLAS DE SEGUIMIENTO DEL ALUMNO',
  originalPrice: '$10.000',
  content: ['Ficha de evaluación inicial del alumno nuevo lista para imprimir', 'Planilla de seguimiento mensual individual por nadador', 'Rúbricas de evaluación técnica para los 4 estilos', 'Planilla grupal de progreso por nivel', 'Registro de asistencia semanal y mensual', 'Modelo de informe trimestral para entregar a padres o institución', 'Todas las planillas en formato editable y listas para imprimir']
}, {
  id: 3,
  icon: <Gamepad2 className="w-8 h-8" data-id="element-19" />,
  title: 'BONO 3 — 50 JUEGOS ACUÁTICOS DIDÁCTICOS',
  originalPrice: '$9.000',
  content: ['50 juegos acuáticos organizados por objetivo pedagógico', 'Clasificados por edad: bebés, niños de 4 a 6, de 7 a 9 y de 10 a 12 años', 'Descripción completa de cada juego: objetivo, materiales, reglas y variantes', 'Juegos para adaptación acuática, flotación, propulsión y técnica', 'Juegos para grupos grandes y grupos reducidos', 'Variantes para distintos niveles dentro del mismo juego', 'Formato imprimible para tener siempre a mano al borde de la pileta']
}, {
  id: 4,
  icon: <MessageCircle className="w-8 h-8" data-id="element-20" />,
  title: 'BONO 4 — GUÍA DE COMUNICACIÓN CON PADRES',
  originalPrice: '$10.000',
  content: ['Cómo hacer la primera reunión de padres: estructura y errores a evitar', 'Scripts listos para 8 situaciones difíciles con padres y cómo responder', 'Modelo de mensaje de bienvenida para el grupo de WhatsApp de padres', 'Cómo comunicar el progreso de un alumno de forma positiva y constructiva', 'Modelo de informe trimestral de progreso listo para completar y entregar', 'Protocolo de comunicación ante una situación de emergencia dentro de la pileta', 'Ficha de datos del alumno y contacto de emergencia lista para imprimir']
}, {
  id: 5,
  icon: <ShieldAlert className="w-8 h-8" data-id="element-21" />,
  title: 'BONO 5 — PROTOCOLO DE SEGURIDAD Y PRIMEROS AUXILIOS',
  originalPrice: '$9.000',
  content: ['Protocolo de emergencia dentro de la pileta paso a paso', 'Primeros auxilios básicos para profes de natación: RCP, atragantamiento y golpe de calor', 'Cómo identificar señales de peligro antes de que ocurra un accidente', 'Las 5 lesiones más frecuentes en natación y cómo prevenirlas', 'Seguridad específica por grupo: bebés, niños, adultos mayores y personas con discapacidad', 'Checklist de seguridad antes de cada clase lista para imprimir', 'Ficha de salud del alumno para completar al inicio del ciclo lectivo']
}, {
  id: 6,
  icon: <Smartphone className="w-8 h-8" data-id="element-22" />,
  title: 'BONO 6 — KIT DE REDES SOCIALES PARA PROFES',
  originalPrice: '$8.000',
  content: ['30 ideas de contenido para Instagram y TikTok para profes de natación', 'Cómo construir tu perfil profesional en redes desde cero', 'Estructura de bio optimizada para atraer alumnos y oportunidades laborales', 'Textos modelo para presentarte como profe en redes sociales', 'Cómo usar las redes para conseguir más alumnos con marketing digital', 'Estrategias para mostrar tu trabajo sin revelar información privada de tus alumnos', 'Calendario de contenido mensual editable para no quedarte sin ideas']
}];
export function BonosSection() {
  const [openId, setOpenId] = useState<number | null>(1);
  return <section className="bg-white py-8 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <div className="text-center mb-6 sm:mb-12" data-id="element-25">
          <span className="bg-red-100 text-red-600 font-bold px-4 py-1.5 rounded-full text-sm mb-4 inline-block" data-id="element-26">
            Incluidos en todas las ofertas — sin costo extra
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-deep mb-4" data-id="element-27">
            Más los 6 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 mb-6 sm:mb-10" data-id="element-28">
          {bonos.map(bono => {
          const isOpen = openId === bono.id;
          return <div key={bono.id} className={`rounded-xl overflow-hidden transition-all duration-300 border relative ${isOpen ? 'bg-light border-agua shadow-md' : 'bg-white border-gray-200 shadow-sm hover:border-agua/50 hover:shadow-md'}`} data-id="element-29">
                <div className="absolute top-3 right-3 flex flex-col items-end" data-id="element-30">
                  <span className="text-xs text-gray-400 line-through font-medium" data-id="element-31">
                    {bono.originalPrice}
                  </span>
                  <span className="text-sm text-green-600 font-black" data-id="element-32">
                    GRATIS
                  </span>
                </div>

                <button onClick={() => setOpenId(isOpen ? null : bono.id)} className="w-full text-left p-3 sm:p-5 flex items-start gap-4 focus:outline-none pr-16" data-id="element-33">
                  <div className={`shrink-0 p-3 rounded-lg ${isOpen ? 'bg-agua text-white' : 'bg-light text-agua'}`} data-id="element-34">
                    {bono.icon}
                  </div>
                  <div className="flex-grow" data-id="element-35">
                    <h3 className="text-base sm:text-lg font-bold text-deep leading-tight mb-1 pr-2" data-id="element-36">
                      {bono.title}
                    </h3>
                  </div>
                  <div className={`shrink-0 mt-1 transition-transform duration-300 absolute bottom-5 right-5 ${isOpen ? 'rotate-180 text-agua' : 'text-gray-400'}`} data-id="element-37">
                    <ChevronDown className="w-5 h-5" data-id="element-38" />
                  </div>
                </button>

                <AnimatePresence data-id="element-39">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-40">
                      <div className="p-5 pt-0 border-t border-agua/20 mt-2" data-id="element-41">
                        <ul className="space-y-2 mt-4" data-id="element-42">
                          {bono.content.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-43">
                              <span className="text-agua font-bold mt-0.5 shrink-0" data-id="element-44">
                                ✓
                              </span>
                              <span data-id="element-45">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="flex justify-center" data-id="element-46">
          <div className="bg-deep text-white px-4 py-2 sm:px-6 sm:py-3 rounded-xl font-bold text-sm sm:text-lg shadow-lg flex items-center gap-3" data-id="element-47">
            <span data-id="element-48">Valor total de los 6 bonos:</span>
            <span className="line-through text-white/60" data-id="element-49">$61.000</span>
            <span className="text-turquoise text-lg sm:text-xl" data-id="element-50">
              → GRATIS 🎁
            </span>
          </div>
        </div>
      </div>
    </section>;
}